const ReelsSkeleton = () => {
    return (
        <div className='relative h-full w-full cursor-pointer overflow-hidden bg-black'>
            <div className='absolute inset-x-0 bottom-8 px-4'>
                <div className='flex'>
                    <div className='flex flex-1 flex-col gap-4 self-end pe-4 text-white'>
                        <div className='flex flex-col gap-2'>
                            <div className='h-3 w-28 animate-pulse rounded bg-gray-400' />
                            <div className='h-3 w-48 animate-pulse rounded bg-gray-400' />
                        </div>
                    </div>
                    <ul className='w-fit space-y-2 self-end text-white'>
                        {[...Array(3)].map((_, i) => (
                            <li key={i} className='cursor-pointer text-center'>
                                <div className='h-[30px] w-[30px] animate-pulse rounded-full bg-gray-400' />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
                <div className='h-10 w-10 animate-spin rounded-full border-4 border-gray-400 border-t-transparent' />
            </div>
        </div>
    );
};

export default ReelsSkeleton;

